import AppPackageJson from '../../package.json';

export const AppPackage = Object.assign(
  {
    devVersion: AppPackageJson.version,
  },
  AppPackageJson
);
